/**
 *
 */

import { ChangeDetectorRef, Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[modal-host]',
  standalone: false,
})
export class ModalDirective {
  public constructor(
    public viewContainerRef: ViewContainerRef,
    public changeDetectorRef: ChangeDetectorRef,
  ) {}
}
